type BrandMarkProps = {
  name: string;
};

const imageMap: Record<string, { src: string; alt: string; className?: string }> = {
  melomeli: {
    src: "/official-brands/melomeli-logo.png",
    alt: "melomeli official logo",
    className: "h-10 w-auto sm:h-12",
  },
  "ROUND LAB": {
    src: "/official-brands/roundlab-logo.png",
    alt: "ROUND LAB official logo",
    className: "h-7 w-auto sm:h-8",
  },
  ILSO: {
    src: "/official-brands/ilso-logo.svg",
    alt: "ILSO official logo",
    className: "h-8 w-auto",
  },
  JMSOLUTION: {
    src: "/official-brands/jmsolution-logo.png",
    alt: "JMsolution official logo",
    className: "h-7 w-auto sm:h-8",
  },
  VT: {
    src: "/official-brands/vt-logo.svg",
    alt: "VT official logo",
    className: "h-7 w-auto sm:h-8",
  },
  "JUNG SAEM MOOL": {
    src: "/official-brands/jsm-logo.png",
    alt: "JUNG SAEM MOOL official logo",
    className: "h-6 w-auto sm:h-7",
  },
  "SUNGBOON EDITOR": {
    src: "/official-brands/sungboon-logo.png",
    alt: "Sungboon Editor official logo",
    className: "h-10 w-auto sm:h-11",
  },
  ONGREDIENTS: {
    src: "/official-brands/ongredients-logo.svg",
    alt: "ongredients official logo",
    className: "h-7 w-auto sm:h-8",
  },
  WENLICI: {
    src: "/official-brands/ongredients-logo.svg",
    alt: "ONGREDIENTS official logo used for the WENLICI market naming",
    className: "h-7 w-auto sm:h-8",
  },
  "juice to cleanse": {
    src: "/official-brands/juice-to-cleanse-logo.png",
    alt: "juice to cleanse official logo",
    className: "h-9 w-auto sm:h-10",
  },
  MEDIHEAL: {
    src: "/official-brands/mediheal-logo.png",
    alt: "Mediheal official logo",
    className: "h-7 w-auto sm:h-8",
  },
  MEDICUBE: {
    src: "/official-brands/medicube-logo.png",
    alt: "Medicube official logo",
    className: "h-7 w-auto sm:h-8",
  },
  CNP: {
    src: "/official-brands/cnp-logo.png",
    alt: "CNP Laboratory official logo",
    className: "h-8 w-auto sm:h-9",
  },
  NUMBUZIN: {
    src: "/brand-placeholders/numbuzin.svg",
    alt: "NUMBUZIN brand mark",
    className: "h-8 w-auto sm:h-9",
  },
  CLIO: {
    src: "/brand-placeholders/clio.svg",
    alt: "CLIO brand mark",
    className: "h-7 w-auto sm:h-8",
  },
};

const textMap: Record<string, { top?: string; bottom?: string; className?: string; wrapperClassName?: string }> = {
  SNP: {
    top: "SNP",
    bottom: "BEAUTY",
    className: "font-display tracking-[0.16em]",
  },
  ILSO: {
    top: "ILSO",
    className: "font-display tracking-[0.2em]",
  },
  NUMBUZIN: {
    top: "NUMBUZIN",
    className: "font-display tracking-[0.14em]",
  },
  Mihwanghoo: {
    top: "MIHWANGHOO",
    bottom: "米皇后",
    className: "font-display tracking-[0.16em]",
  },
  CLIO: {
    top: "CLIO",
    className: "font-display tracking-[0.22em]",
  },
  WAKEMAKE: {
    top: "WAKEMAKE",
    className: "font-display tracking-[0.14em]",
  },
  RATAPLAN: {
    top: "RATAPLAN",
    className: "font-display tracking-[0.18em]",
  },
  "de noah": {
    top: "de noah",
    className: "font-display normal-case tracking-[0.12em]",
  },
  Calvisana: {
    top: "Calvisana",
    bottom: "CAVIAR CARE",
    className: "font-serif tracking-[0.12em]",
  },
  BONABELLA: {
    top: "BONABELLA",
    className: "font-display tracking-[0.16em]",
  },
  belif: {
    top: "belif",
    className: "font-serif normal-case tracking-[0.08em]",
  },
  BEYOND: {
    top: "BEYOND",
    className: "font-display tracking-[0.2em]",
  },
  efilow: {
    top: "efilow",
    className: "font-display normal-case tracking-[0.1em]",
  },
  WENLICI: {
    top: "WENLICI",
    bottom: "温丽慈",
    className: "font-display tracking-[0.16em]",
  },
  "Real Derma": {
    top: "Real Derma",
    className: "font-display normal-case tracking-[0.08em]",
  },
  "THE PALACE SECRET": {
    top: "THE PALACE",
    bottom: "SECRET",
    className: "font-serif tracking-[0.22em]",
  },
};

export function BrandMark({ name }: BrandMarkProps) {
  const image = imageMap[name];
  const config = textMap[name] ?? {
    top: name,
    className: "font-display tracking-[0.18em]",
  };

  return (
    <div className="group flex min-h-[4.65rem] items-center justify-center rounded-[1.45rem] border border-[#dce8ee] bg-[linear-gradient(180deg,rgba(252,254,255,0.98),rgba(241,247,250,0.96))] px-4 py-3 text-center text-[#223036] shadow-[0_8px_18px_rgba(106,138,151,0.04)] transition hover:-translate-y-0.5 hover:border-[#cddfe7] hover:bg-white hover:shadow-[0_14px_26px_rgba(106,138,151,0.07)]">
      {image ? (
        <img src={image.src} alt={image.alt} className={`${image.className ?? "h-8 w-auto"} max-w-[82%] object-contain`} />
      ) : (
        <div className={`${config.wrapperClassName ?? ""} ${config.className}`}>
          <div className="text-[1.04rem] font-semibold sm:text-[1.2rem]">{config.top}</div>
          {config.bottom ? (
            <div className="mt-1.5 text-[9px] font-medium tracking-[0.32em] sm:text-[10px]">
              {config.bottom}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}
